import { ThemeProvider } from '@mui/material';
import { theme } from '@shared/config';

export const Mui: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};
